import './UserForm.css';
import React from 'react';
import GlobalProps from '../../../components/globalProps';
import { UserEdit, addUser, patchUser } from '../../../model/user';
import { ModalController } from '../../../components/Modal/ControlledModal';
import { TextField } from '../../../components/Form/TextField/TextField';
import { t } from '../../../locales/translate';
import { Form, useChanges } from '../../../components/Form/Form';
import { handleError } from '../../../model/notification';
import { Stack } from '../../../components/Stack/Stack';

interface Props extends GlobalProps {
  controller: ModalController<UserEdit>;
  onSuccess?: () => void;
}

export function UserForm({ controller, onSuccess }: Props): JSX.Element {
  const [changes, , user, trackChanges] = useChanges<UserEdit>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    try {
      if (!user.id) {
        await addUser(changes);
      } else {
        await patchUser(user.id, user);
      }
      onSuccess?.();
      controller.close();
    } catch (e) {
      handleError(e);
    }
  }

  return (
    <Form model={user} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <Stack>
            <TextField name="firstName" label={t.model.user.firstName} />
            <TextField name="lastName" label={t.model.user.lastName} />
            <TextField required name="email" type="email" label={t.model.user.email} />
            <TextField name="phone" label={t.model.user.phone} />
          </Stack>
        );
      }}
    </Form>
  );
}
